<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-03-28',
        major: [
          '第1弾',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-01',
            rare        : 'KR',
            name        : 'スイートハニーキラッとワンピ',
            imgUrl      : '/images/items/PCH1-01.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-02',
            rare        : 'KR',
            name        : 'スイートハニーキラッとシューズ',
            imgUrl      : '/images/items/PCH1-02.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-03',
            rare        : 'KR',
            name        : 'スイートハニーキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH1-03.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-04',
            rare        : 'PR',
            name        : 'フラワーショップフリージアトップス',
            imgUrl      : '/images/items/PCH1-04.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-05',
            rare        : 'PR',
            name        : 'フラワーショップフリージアスカート',
            imgUrl      : '/images/items/PCH1-05.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-06',
            rare        : 'PR',
            name        : 'フラワーショップフリージアシューズ',
            imgUrl      : '/images/items/PCH1-06.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-07',
            rare        : 'PR',
            name        : 'フラワーショップフリージアヘアアクセ',
            imgUrl      : '/images/items/PCH1-07.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-08',
            rare        : 'PR',
            name        : 'フラワーショップブルースタートップス',
            imgUrl      : '/images/items/PCH1-08.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-09',
            rare        : 'PR',
            name        : 'フラワーショップブルースタースカート',
            imgUrl      : '/images/items/PCH1-09.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 6 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-10',
            rare        : 'PR',
            name        : 'フラワーショップブルースターシューズ',
            imgUrl      : '/images/items/PCH1-10.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 5 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-11',
            rare        : 'PR',
            name        : 'フラワーショップブルースターヘアアクセ',
            imgUrl      : '/images/items/PCH1-11.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-12',
            rare        : 'PR',
            name        : 'チアリーダーグリーントップス',
            imgUrl      : '/images/items/PCH1-12.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 6 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-13',
            rare        : 'PR',
            name        : 'チアリーダーグリーンスカート',
            imgUrl      : '/images/items/PCH1-13.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-14',
            rare        : 'PR',
            name        : 'チアリーダーグリーンシューズ',
            imgUrl      : '/images/items/PCH1-14.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-15',
            rare        : 'PR',
            name        : 'チアリーダーグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH1-15.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-16',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルートップス',
            imgUrl      : '/images/items/PCH1-16.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-17',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルースカート',
            imgUrl      : '/images/items/PCH1-17.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-18',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルーシューズ',
            imgUrl      : '/images/items/PCH1-18.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-19',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルーヘアアクセ',
            imgUrl      : '/images/items/PCH1-19.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-20',
            rare        : 'SR',
            name        : 'アイスクリームミントワンピ',
            imgUrl      : '/images/items/PCH1-20.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-21',
            rare        : 'SR',
            name        : 'アイスクリームミントシューズ',
            imgUrl      : '/images/items/PCH1-21.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-22',
            rare        : 'SR',
            name        : 'アイスクリームミントヘアアクセ',
            imgUrl      : '/images/items/PCH1-22.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'SR',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-23',
            rare        : 'SR',
            name        : 'ポップコーンショップレッドトップス',
            imgUrl      : '/images/items/PCH1-23.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-24',
            rare        : 'SR',
            name        : 'ポップコーンショップレッドパンツ',
            imgUrl      : '/images/items/PCH1-24.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-25',
            rare        : 'SR',
            name        : 'ポップコーンショップレッドシューズ',
            imgUrl      : '/images/items/PCH1-25.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-26',
            rare        : 'SR',
            name        : 'ポップコーンショップレッドヘアアクセ',
            imgUrl      : '/images/items/PCH1-26.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-27',
            rare        : 'SR',
            name        : 'バルーンホワイトデニムサロペット',
            imgUrl      : '/images/items/PCH1-27.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 1200,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-28',
            rare        : 'SR',
            name        : 'バルーンホワイトデニムシューズ',
            imgUrl      : '/images/items/PCH1-28.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-29',
            rare        : 'SR',
            name        : 'バルーンホワイトデニムヘアアクセ',
            imgUrl      : '/images/items/PCH1-29.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-30',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクトップス',
            imgUrl      : '/images/items/PCH1-30.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-31',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクスカート',
            imgUrl      : '/images/items/PCH1-31.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-32',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクシューズ',
            imgUrl      : '/images/items/PCH1-32.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-33',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクヘアアクセ',
            imgUrl      : '/images/items/PCH1-33.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-34',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームイエロートップス',
            imgUrl      : '/images/items/PCH1-34.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'PS',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-35',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームイエロースカート',
            imgUrl      : '/images/items/PCH1-35.png',
            kind        : 'スカート',
            color       : '黄',
            brand       : 'PS',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-36',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームイエローシューズ',
            imgUrl      : '/images/items/PCH1-36.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'PS',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-37',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームイエローヘアアクセ',
            imgUrl      : '/images/items/PCH1-37.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'PS',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-38',
            rare        : 'R',
            name        : 'スプリングリボンワンピ',
            imgUrl      : '/images/items/PCH1-38.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-39',
            rare        : 'R',
            name        : 'スプリングリボンパンプス',
            imgUrl      : '/images/items/PCH1-39.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-40',
            rare        : 'R',
            name        : 'ポップスターブルーTシャツ',
            imgUrl      : '/images/items/PCH1-40.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-41',
            rare        : 'R',
            name        : 'ポップスターイエローキャップスカート',
            imgUrl      : '/images/items/PCH1-41.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-42',
            rare        : 'R',
            name        : 'ポップスターブルースニーカー',
            imgUrl      : '/images/items/PCH1-42.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-43',
            rare        : 'R',
            name        : 'グレンチェックビスチェ',
            imgUrl      : '/images/items/PCH1-43.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-44',
            rare        : 'R',
            name        : 'グレンチェックボトムス',
            imgUrl      : '/images/items/PCH1-44.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-45',
            rare        : 'R',
            name        : 'グレンチェックシューズ',
            imgUrl      : '/images/items/PCH1-45.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-46',
            rare        : 'R',
            name        : 'ビビッドアルファベットパーカ',
            imgUrl      : '/images/items/PCH1-46.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-47',
            rare        : 'R',
            name        : 'ビビッドラメボトムス',
            imgUrl      : '/images/items/PCH1-47.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-48',
            rare        : 'R',
            name        : 'ビビッドアルファベットスニーカー',
            imgUrl      : '/images/items/PCH1-48.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-49',
            rare        : 'N',
            name        : 'フルレースラベンダートップス',
            imgUrl      : '/images/items/PCH1-49.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-50',
            rare        : 'N',
            name        : 'フルレースラベンダースカート',
            imgUrl      : '/images/items/PCH1-50.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-51',
            rare        : 'N',
            name        : 'フルレースラベンダーシューズ',
            imgUrl      : '/images/items/PCH1-51.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-52',
            rare        : 'N',
            name        : 'クリームソーダトップス',
            imgUrl      : '/images/items/PCH1-52.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-53',
            rare        : 'N',
            name        : 'クリームソーダボトムス',
            imgUrl      : '/images/items/PCH1-53.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-54',
            rare        : 'N',
            name        : 'クリームソーダシューズ',
            imgUrl      : '/images/items/PCH1-54.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-55',
            rare        : 'N',
            name        : 'ダンシングマーチトップス',
            imgUrl      : '/images/items/PCH1-55.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-56',
            rare        : 'N',
            name        : 'ダンシングマーチボトムス',
            imgUrl      : '/images/items/PCH1-56.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-57',
            rare        : 'N',
            name        : 'ダンシングマーチシューズ',
            imgUrl      : '/images/items/PCH1-57.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-58',
            rare        : 'N',
            name        : 'スイートドーナツブラウス',
            imgUrl      : '/images/items/PCH1-58.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-59',
            rare        : 'N',
            name        : 'スイートドーナツボトムス',
            imgUrl      : '/images/items/PCH1-59.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-60',
            rare        : 'N',
            name        : 'スイートストライプシューズ',
            imgUrl      : '/images/items/PCH1-60.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-61',
            rare        : 'N',
            name        : 'モノトーンフリルカーデ',
            imgUrl      : '/images/items/PCH1-61.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-62',
            rare        : 'N',
            name        : 'モノトーンフリルスカート',
            imgUrl      : '/images/items/PCH1-62.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-63',
            rare        : 'N',
            name        : 'モノトーンパンプス',
            imgUrl      : '/images/items/PCH1-63.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-64',
            rare        : 'N',
            name        : 'グリーンチェックワンピ',
            imgUrl      : '/images/items/PCH1-64.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-65',
            rare        : 'N',
            name        : 'グリーンチェックリボンシューズ',
            imgUrl      : '/images/items/PCH1-65.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),
          item({
            collection  : '第1弾',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '第1弾',
            id          : 'PCH1-66',
            rare        : 'SR',
            name        : 'ピンクフラワーブーケ',
            imgUrl      : '/images/items/PCH1-66.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-67',
            rare        : 'SR',
            name        : 'ミルキーアイスクリーム',
            imgUrl      : '/images/items/PCH1-67.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-68',
            rare        : 'SR',
            name        : 'カラフルキャンディー',
            imgUrl      : '/images/items/PCH1-68.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '第1弾',
            id          : 'PCH1-69',
            rare        : 'R',
            name        : 'ショートケーキ',
            imgUrl      : '/images/items/PCH1-69.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            id          : 'PCH1-70',
            rare        : 'R',
            name        : 'スタンダードマイク',
            imgUrl      : '/images/items/PCH1-70.png',
            kind        : 'パシャッとアイテム',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '第1弾',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] 期間限定チャンネル
          // ================================================================================

          item({
            collection  : 'キラ宿スイーツフェスティバル',
            id          : 'PCH1-71',
            rare        : 'SR',
            name        : 'ストロベリーガールピンクワンピ',
            imgUrl      : '/images/items/PCH1-71.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿スイーツフェスティバル',
            id          : 'PCH1-72',
            rare        : 'SR',
            name        : 'ストロベリーガールピンクシューズ',
            imgUrl      : '/images/items/PCH1-72.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿スイーツフェスティバル',
            id          : 'PCH1-73',
            rare        : 'SR',
            name        : 'ストロベリーガールピンクヘアアクセ',
            imgUrl      : '/images/items/PCH1-73.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿スイーツフェスティバル',
            rare        : 'SR',
          }),


          // [NOTE] ブランドチャンネル
          // ================================================================================

          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-01',
            rare        : 'SR',
            name        : 'ギンガムハートサンレッドトップス',
            imgUrl      : '/images/items/SH-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-02',
            rare        : 'SR',
            name        : 'ギンガムハートサンレッドスカート',
            imgUrl      : '/images/items/SH-02.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-03',
            rare        : 'SR',
            name        : 'ギンガムハートサンレッドシューズ',
            imgUrl      : '/images/items/SH-03.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-04',
            rare        : 'SR',
            name        : 'ギンガムハートサンレッドヘアアクセ',
            imgUrl      : '/images/items/SH-04.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-05',
            rare        : 'SR',
            name        : 'アイスクリームグレープワンピ',
            imgUrl      : '/images/items/SH-05.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1200,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-06',
            rare        : 'SR',
            name        : 'アイスクリームグレープシューズ',
            imgUrl      : '/images/items/SH-06.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-07',
            rare        : 'SR',
            name        : 'アイスクリームグレープヘアアクセ',
            imgUrl      : '/images/items/SH-07.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-01',
            rare        : 'SR',
            name        : 'バルーンブルーデニムサロペット',
            imgUrl      : '/images/items/GY-01.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 1200,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-02',
            rare        : 'SR',
            name        : 'バルーンブルーデニムシューズ',
            imgUrl      : '/images/items/GY-02.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-03',
            rare        : 'SR',
            name        : 'バルーンブルーデニムヘアアクセ',
            imgUrl      : '/images/items/GY-03.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-04',
            rare        : 'SR',
            name        : 'ポップコーンショップグリーントップス',
            imgUrl      : '/images/items/GY-04.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-05',
            rare        : 'SR',
            name        : 'ポップコーンショップグリーンパンツ',
            imgUrl      : '/images/items/GY-05.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-06',
            rare        : 'SR',
            name        : 'ポップコーンショップグリーンシューズ',
            imgUrl      : '/images/items/GY-06.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-07',
            rare        : 'SR',
            name        : 'ポップコーンショップグリーンヘアアクセ',
            imgUrl      : '/images/items/GY-07.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, {  rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, {  rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsKSFestival () {
        return _.where(this.itemsFiltered, { collection: 'キラ宿スイーツフェスティバル' })
      },

      itemsSHChannel () {
        return _.where(this.itemsFiltered, { collection: 'Sweet Honey チャンネル' })
      },

      itemsGYChannel () {
        return _.where(this.itemsFiltered, { collection: 'Girl\'s Yell チャンネル' })
      },

    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[4,5]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col5>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col6>
      <ItemList title="キラ宿スイーツフェスティバル" color="#a1c0fa" :items="itemsKSFestival" />
      <ItemList title="Sweet Honey チャンネル" color="#a1c0fa" :items="itemsSHChannel" />
      <ItemList title="Girl's Yell チャンネル" color="#a1c0fa" :items="itemsGYChannel" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    margin-left: -$size-unit * 96;
    bottom: $size-unit * 10;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
